import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { X } from "lucide-react";
import { Button, InputGroup, Label, Spinner, TextField } from "@heroui/react";
import { UserAPI } from "@repo/api/user";
import type { Rsp } from "@repo/types";
import toast from "react-hot-toast";
import { CountryCodeSelect } from "@/components/from/country-code-select";
import { recoveryCountryCodes } from "@/data/country-codes";

export const Route = createFileRoute("/help/account_recovery/phone")({
  component: AccountRecoveryPhone,
});

export default function AccountRecoveryPhone() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("86");
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleNext = () => {
    if (!phoneNumber) {
      toast.error("请输入手机号");
      return;
    }
    setLoading(true);
    UserAPI.findUserByPhone(countryCode, phoneNumber)
      .then(
        (res) => {
          if (!res.data.ticket) return;
          navigate({
            to: "/help/account_recovery/face_verify",
            search: { recovery_ticket: res.data.ticket },
          });
        },
        (err: Rsp<null>) => {
          toast.error(err.msg || "操作失败");
        },
      )
      .finally(() => setLoading(false));
  };

  return (
    <div className={"min-h-screen flex flex-col items-center px-4"}>
      <div className={"text-3xl text-black-800 mt-8 mb-4 text-center font-bold"}>
        输入原手机号
      </div>
      <div className={"text-md text-gray-500 text-center"}>
        使用绑定的手机号来识别您的身份，通过人脸验证后即可更换新手机号
      </div>

      <TextField
        name="phone"
        fullWidth
        className="w-full max-w-md my-8"
        isDisabled={loading}
        value={phoneNumber}
        onChange={setPhoneNumber}
      >
        <Label>手机号码</Label>
        <InputGroup fullWidth>
          <InputGroup.Prefix className="ps-0">
            <CountryCodeSelect
              countries={recoveryCountryCodes}
              value={countryCode}
              onChange={setCountryCode}
              disabled={loading}
            />
          </InputGroup.Prefix>
          <InputGroup.Input type="tel" placeholder="请输入手机号" />
          {phoneNumber !== "" && (
            <InputGroup.Suffix className="pe-0">
              <Button
                isIconOnly
                aria-label="清除"
                size="sm"
                variant="ghost"
                isDisabled={loading}
                onPress={() => setPhoneNumber("")}
              >
                <X className="size-4" />
              </Button>
            </InputGroup.Suffix>
          )}
        </InputGroup>
      </TextField>
      <div className="flex flex-row justify-center mt-2 w-full max-w-md">
        <Button
          className="w-full rounded-full"
          type="button"
          isPending={loading}
          isDisabled={loading || phoneNumber === ""}
          onPress={handleNext}
        >
          {({ isPending }) => (
            <>
              {isPending && <Spinner size="sm" color="current" />}
              下一步
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
